'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppDevAuthToken(email) {
  this.Lapp_data_AppDevAuthToken__f_email = null;
  this.Lapp_data_AppDevAuthToken__f_email = email;
}
export { $c_Lapp_data_AppDevAuthToken as $c_Lapp_data_AppDevAuthToken };
$c_Lapp_data_AppDevAuthToken.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppDevAuthToken.prototype.constructor = $c_Lapp_data_AppDevAuthToken;
/** @constructor */
function $h_Lapp_data_AppDevAuthToken() {
}
export { $h_Lapp_data_AppDevAuthToken as $h_Lapp_data_AppDevAuthToken };
$h_Lapp_data_AppDevAuthToken.prototype = $c_Lapp_data_AppDevAuthToken.prototype;
$c_Lapp_data_AppDevAuthToken.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppDevAuthToken.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1791567261, true);
});
$c_Lapp_data_AppDevAuthToken.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_AppDevAuthToken) && (this.Lapp_data_AppDevAuthToken__f_email === x$0.Lapp_data_AppDevAuthToken__f_email)));
});
$c_Lapp_data_AppDevAuthToken.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppDevAuthToken.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AppDevAuthToken.prototype.productPrefix__T = (function() {
  return "AppDevAuthToken";
});
$c_Lapp_data_AppDevAuthToken.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AppDevAuthToken__f_email;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppDevAuthToken.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "email";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AppDevAuthToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppDevAuthToken)));
}
export { $isArrayOf_Lapp_data_AppDevAuthToken as $isArrayOf_Lapp_data_AppDevAuthToken };
var $d_Lapp_data_AppDevAuthToken = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppDevAuthToken, "app.data.AppDevAuthToken", ({
  Lapp_data_AppDevAuthToken: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_AppDevAuthToken as $d_Lapp_data_AppDevAuthToken };
//# sourceMappingURL=app.data.-App-Dev-Auth-Token.js.map
